"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var element_1 = require("../element");
var __1 = require("..");
var utils_1 = require("../template/utils");
var LineChart = /** @class */ (function (_super) {
    __extends(LineChart, _super);
    function LineChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Whether x/y should be inversed */
        _this._isInversedX = false;
        _this._isInversedY = false;
        _this._isHorizontal = false;
        return _this;
    }
    LineChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_gravity":
                return {
                    top: __1.Gravity.Top, bottom: __1.Gravity.Bottom, left: __1.Gravity.Left, right: __1.Gravity.Right,
                }[value];
            case "_valueFunc":
            case "_xFunc":
                return utils_1.parseFunc(value);
            case "_minValue":
            case "_maxValue":
            case "_maxX":
            case "_minX":
            case "_r":
                return utils_1.parseNumberWithAuto(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    LineChart.prototype.defaultOptions = function () {
        return {
            _minValue: -1,
            _maxValue: -1,
            _minX: -1,
            _maxX: -1,
            _gravity: __1.Gravity.Bottom,
            _r: 2,
            _valueFunc: function (d) { return d.x; },
            _xFunc: function (d) { return d.value; },
        };
    };
    LineChart.prototype.init = function () {
        var _this = this;
        this._xScale = d3.scaleLinear();
        this._yScale = d3.scaleLinear();
        this._toolTip = __1.tooltip.create("linetip");
        this._groups = this.appendGroupT(_1.Component).data([]).options({});
        var linesData = function (d, i) { return [{
                path: d.map(function (obj, j) {
                    var x = _this._xScale(obj.x);
                    var y = _this._yScale(obj.value);
                    return "" + (j === 0 ? "M" : "L") + (_this._isHorizontal ? y : x) + "," + (_this._isHorizontal ? x : y);
                }).join(""),
                category: d[i].category,
            }]; };
        this._lines = this._groups.appendGroupT(element_1.Path).data(linesData).options({
            d: function (d, i) { return d.path; },
            stroke: "#fff",
        });
        this._points = this._groups.appendGroupT(element_1.Circle).data([]).options({
            _data: function (d) { return d; },
            _r: function (d) { return d.radius; },
            _anchor: 32 /* Center */ | 4 /* Middle */,
            _x: function (d) { return _this._isHorizontal ? _this._yScale(d.value) : _this._xScale(d.x); },
            _y: function (d) { return _this._isHorizontal ? _this._xScale(d.x) : _this._yScale(d.value); },
            fill: "#fff",
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._points.dom)
                    .renderHTML(function (d) {
                    return "(" + d.x + ", " + d.value + ")";
                });
            },
        });
    };
    LineChart.prototype.getGravityY = function (gra) {
        switch (gra) {
            case __1.Gravity.Right: return __1.Gravity.Bottom;
            case __1.Gravity.Top: return __1.Gravity.Right;
            // pre3 hard fix
            case __1.Gravity.Left: return __1.Gravity.Bottom;
            case __1.Gravity.Bottom: return __1.Gravity.Left;
        }
    };
    LineChart.prototype.prepare = function () {
        var _this = this;
        var gravity = this.getOption("_gravity");
        var gravityY = this.getGravityY(gravity);
        this._isHorizontal = gravity === __1.Gravity.Left || gravity === __1.Gravity.Right;
        this._isInversedX = gravity === __1.Gravity.Right || gravity === __1.Gravity.Top;
        this._isInversedY = gravity === __1.Gravity.Top || gravity === __1.Gravity.Left;
        var xOp = this.getOption("_xFunc");
        var yOp = this.getOption("_valueFunc");
        var dataArray = Object.keys(this.datum).map(function (k) {
            return _this.datum[k].map(function (d, i) { return ({
                x: xOp(d, i),
                value: yOp(d, i),
                category: k,
                radius: _this.getOption("_r"),
            }); });
        });
        this._groups.data(dataArray);
        var svgMaxY = this._getGeometry("_height", false);
        var svgMaxX = this._getGeometry("_width", true);
        var totalY = this._isHorizontal ? svgMaxY : svgMaxX;
        var totalX = this._isHorizontal ? svgMaxX : svgMaxY;
        this._axisMaxX = this.getOption("_maxX") === -1 ? d3.max(dataArray, function (d) { return d3.max(d, function (x) { return x.x; }); }) : this.getOption("_maxX");
        var axisMinX = this.getOption("_minX") === -1 ? d3.min(dataArray, function (d) { return d3.min(d, function (x) { return x.x; }); }) : this.getOption("_minX");
        this._axisMaxValue = this.getOption("_maxValue") === -1 ? d3.max(dataArray, function (d) { return d3.max(d, function (x) { return x.value; }); }) : this.getOption("_maxValue");
        var axisMinValue = this.getOption("_minValue") === -1 ? d3.min(dataArray, function (d) { return d3.min(d, function (x) { return x.value; }); }) : this.getOption("_minValue");
        this._xScale.domain([axisMinX, this._axisMaxX]).nice().range(this._isInversedX ? [totalY, 0] : [0, totalY]);
        this._yScale.domain([axisMinValue, this._axisMaxValue]).nice().range(this._isInversedY ? [0, totalX] : [totalX, 0]);
        this.setupProxy({
            yAxis: function (axis) {
                axis.options({
                    _scale: _this._yScale,
                    _gravity: gravityY,
                    _x: gravity === __1.Gravity.Top ? totalY : 0,
                    _y: gravity === __1.Gravity.Left ? totalY : 0,
                });
            },
            xAxis: function (axis) {
                axis.options({
                    _scale: _this._xScale,
                    _gravity: gravity,
                    _x: gravity === __1.Gravity.Right ? totalX : 0,
                    _y: gravity === __1.Gravity.Bottom ? totalX : 0,
                });
            },
            line: "_lines",
            point: "_points",
        });
    };
    return LineChart;
}(_1.Component));
exports.LineChart = LineChart;
//# sourceMappingURL=line-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/line-chart.js
// module id = 1157
// module chunks = 0 1